import { rootApi } from "../../api/rootApi";

export const referApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchReferralUser: builder.mutation({
            query: (params) => {
                let url = `/tenant/referralAndEarn/user-list?limit=${params.limit}&offset=${params.offset}`
                if (params.mobile) {
                    url += `&mobile=${params.mobile}`
                }
                return {
                    method: "GET",
                    url: url,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.body,
                };
            },
        })
    })
});

export const {
    useFetchReferralUserMutation
} = referApi;
